var PALETTE = {
    BLACK_ALPHA20: 'rgba(0, 0, 0, 0.2)',
    BLACK_ALPHA30: 'rgba(0, 0, 0, 0.3)',
    BLACK_ALPHA50: 'rgba(0, 0, 0, 0.5)',
    BLACK: '#000000',
    VERY_DARK_GRAY_ALPHA10: 'rgba(85, 85, 85, 0.1)',
    VERY_DARK_GRAYISH_BLUE: '#47545a',
    VERY_DARK_GRAYISH_BLUE_2: '#29363b',
    DARK_GRAYISH_CYAN: '#697275',
    VERY_DARK_GRAY: '#555555',
    DARK_GRAY: '#777777',
    DARK_GRAY_2: '#999999',
    GRAY: '#b2b2b2',
    LIGHT_GRAY: '#c7c7c7',
    LIGHT_GRAY_2: '#cccccc',
    LIGHT_GRAY_3: '#d6d6d6',
    VERY_LIGHT_GRAY: '#dddddd',
    VERY_LIGHT_GRAY_2: '#eeeeee',
    VERY_LIGHT_GRAY_3: '#f0f0f0',
    VERY_LIGHT_GRAY_4: '#f7f7f7',
    VERY_LIGHT_GRAY_5: '#f9f9f9',
    VERY_LIGHT_GRAY_6: '#fafafa',
    VERY_LIGHT_GRAY_7: '#fdfdfd',
    SOFT_RED: '#fc6356',
    VERY_PALE_RED: '#ffeeec',
    STRONG_BLUE: '#1987b3',
    STRONG_BLUE_2: '#0892c7',
    STRONG_BLUE_3: '#1c9cce',
    STRONG_GREEN: '#6fc02c',
    VERY_PALE_BLUE: '#e5f4ff',
    VERY_PALE_BLUE_2: '#f0faff',
    SOFT_BLUE: '#4ebfea',
    VIVID_BLUE: '#20aee5',
    WHITE: '#ffffff',
};
export default PALETTE;
//# sourceMappingURL=palette.js.map